<template>
  <div
    v-if="multipleTerminals"
    id="select-terminal"
  >
    <div class="col-heading">
      <h3 class="mb-4">
        Terminal
      </h3>
    </div>
    <div class="form-check form-radio-inline">
      <label
        v-if="!hideDoNotKnowOption"
      >
        <input
          id="doNotKnow"
          v-model="selectedTerminalId"
          type="radio"
          checked="checked"
          name="doNotKnow"
          value="0"
        >
        <div
          class="radio-label"
          for="doNotKnow"
        >
          <b>I don't know</b>
        </div>
      </label>
      <label
        v-for="(terminal, index) in terminals"
        :key="index"
        class="form-group form-check form-check-inline"
      >
        <input
          :id="terminal.name"
          v-model="selectedTerminalId"
          :disabled="disabled"
          :value="terminal.id"
          :name="terminal.name"
          type="radio"
        >
        <div
          :for="terminal.name"
          class="radio-label"
        >
          <b>{{ terminal.name }}</b>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
    name: 'SelectTerminal',
    props: {
        hideDoNotKnowOption: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        terminals: {
            get () {
                const airport = this.$store.getters['getSelectedAirport']
                return airport !== undefined ? airport.terminals : []
            }
        },
        multipleTerminals () {
            if (this.terminals) {
                return this.terminals.length > 1
            } else {
                return false
            }
        },
        selectedTerminalId: {
            get () {
                return this.$store.state.airport.selectedTerminalId
            },
            set (value) {
                this.$store.commit('setSelectedTerminalId', parseInt(value))
            }
        }
    }
}
</script>
